import { ApiResponse } from "@/utils/ApiResponse";
import apiClient from "@/clients/apiClient";
import { MarcaProductoInterface } from "../../interfaces/marcaProductosInterfaces/MarcaProducto.interface";
export async function MarcaProductoCreateAction(
  formData: FormData
): Promise<ApiResponse<MarcaProductoInterface>> {
  const { data } = await apiClient.post<MarcaProductoInterface>(
    "/gpMarcaProductos",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return {
    status: 200,
    data,
    message: "Marca de productos creada correctamente",
  };
}
